import { Card, Divider } from "antd";
import { ClipboardCheck, TrendingUp } from "lucide-react";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import PerformanceHeader from "./PerformanceHeader";


const AttendanceSummary = ( props ) => {
  const {} = props;

  const attendanceRate = [
  {   
    id: 1,
    label: "Attendance Rate",
    percentage: 0,
  },
  {   
    id: 2,
    label: "Punctuality",
    percentage: 0,
  },
]
  
  	return (
      <PerformanceHeader
          title="Attendance Summary"
          description="October 2025 metrics"
					icon={<ClipboardCheck size={20}/>}
          cardTheme="white-blue"
      >
        <div className="grid grid-cols-2 gap-3 mb-4">
          {attendanceRate.map((item) => (
            <div className="p-3 rounded-xl bg-white border border-blue-100 dark-mode-card">
              <p className="text-[10px] mb-1 title-text">{item.label}</p>
              <p className="text-[20px] font-bold card-text">{item.percentage}%</p>
            </div>
          ))}
        </div>
          <div className="flex items-center justify-between text-[11px]">
            <span className="muted-text">Hours Worked:</span>
            <span className="font-semibold title-text">0 / 176</span>
          </div>          
          <div className="flex items-center justify-between text-[11px]">
            <span className="muted-text">On-Time Check-ins:</span>
            <span className="font-semibold text-green-600 dark:text-green-500">0 days</span>
          </div>
          <div className="flex items-center justify-between text-[11px]">
            <span className="muted-text">Late Check-ins:</span>
            <span className="font-semibold text-amber-600 dark:text-amber-500">0 day</span>
          </div>

           <Divider style={{ margin: "0.5rem 0", borderColor: "#e5e7eb" }} />

          <div className="flex items-center justify-between text-[11px]">
            <span className="muted-text">Year to Date</span>
            <span className="font-semibold title-text"></span>
          </div>
          <div className="flex items-center justify-between text-[11px]">
            <span className="muted-text">YTD Attendance:</span>
            <span className="font-semibold title-text">0%</span>
          </div>
      </PerformanceHeader>
				
              


);
};

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(AttendanceSummary);
